import React from 'react';
import SocialList from './Social/SocialList';
import { footerContent } from '../utils/data';

const Footer = ({ lang }) => {
  const { socialText, description, copyright } = footerContent[lang];

  return (
    <footer className="main-footer">
      <div className="main-container">
        <div className="main-footer__upper">
          <div className="main-footer__row main-footer__row-1">
            <h2 className="heading heading-sm main-footer__heading-sm">
              <span>{socialText}</span>
            </h2>
            <SocialList
              containerClass="main-footer__social-cont"
              iconClass="main-footer__icon"
            />
          </div>
          <div className="main-footer__row main-footer__row-2">
            <h4 className="heading heading-sm text-lt">Jorge Casagrande</h4>
            <p className="main-footer__short-desc">{description}</p>
          </div>
        </div>
        <div className="main-footer__lower">
          {copyright}
        </div>
      </div>
    </footer>
  );
};

export default Footer;